import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

export function AuthGuard() {
  const { t } = useTranslation('common');
  const { session, loading } = useAuth();

  if (loading) return <p>{t('loading')}</p>;
  if (!session) return <Navigate to="/login" replace />;

  return <Outlet />;
}
